import { getPublicEnv } from '@tucan/utils'
import axios, { AxiosRequestConfig } from 'axios'
import { useCallback, useState } from 'react'

export const useApiProxy = (url: string) => {
  const [ data, setData ] = useState(null)
  const [ loading, setLoading ] = useState(false)
  const [ error, setError] = useState()

  const trigger = useCallback(async (config: AxiosRequestConfig, customUrl?: string) => {
    setLoading(true)
    setData(null)
    setError(null)
    try {
      const res = await axios(getPublicEnv('ENDPOINT') + (customUrl ?? url), config)

      setData(res.data)
      setLoading(false)

      return res.data
    } catch(error) {
      setError(error)
      throw error
    }
  }, [url])

  return { data, error, loading, trigger }
}
